import React from 'react';
import { StandardButton } from '@eika/button';
import { CheckmarkAnimation } from '@eika/checkmark-animation';
const Finish = _ref => {
  let {
    finishedText,
    onFinishRedirectURL,
    hidePrintInformationInFinalPage
  } = _ref;
  const done = () => {
    if (onFinishRedirectURL) {
      window.location.href = onFinishRedirectURL;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "center-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "thank-you-icon-wrapper"
  }, /*#__PURE__*/React.createElement(CheckmarkAnimation, null)), /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("h2", null, finishedText && finishedText.length > 0 ? finishedText : 'Takk for hjelpen.')), !hidePrintInformationInFinalPage ? /*#__PURE__*/React.createElement("p", {
    className: "no-margin-paragraph"
  }, "\xD8nsker du utskrift av dine svar kan du ta kontakt med banken.") : undefined, /*#__PURE__*/React.createElement(StandardButton, {
    type: "button",
    className: "progress-next-button",
    onClick: done,
    id: "questionnaire_button_done"
  }, onFinishRedirectURL ? 'Tilbake til oppgavelisten' : 'Gå videre'));
};
export default Finish;